import { useInView } from '../hooks/useInView';
import { education, certifications } from '../data/portfolioData';

export default function Education() {
  const [ref, inView] = useInView(0.1);

  return (
    <section id="education" ref={ref}>
      <div className="max-w-5xl mx-auto px-6 lg:px-16 py-24">
        <div className={`reveal ${inView ? 'visible' : ''}`}>
          <div className="section-eyebrow">05 — Academic journey</div>
        </div>
        <h2 className={`reveal ${inView ? 'visible' : ''} delay-1`}
          style={{ fontSize: 'clamp(2rem,5vw,3.2rem)', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: '0.75rem' }}>
          Education
        </h2>
        <p className={`reveal ${inView ? 'visible' : ''} delay-2`}
          style={{ color: 'var(--text2)', fontSize: '1.05rem', maxWidth: 520, lineHeight: 1.7, marginBottom: '3.5rem' }}>
          Building the foundations of engineering and data science.
        </p>

        {/* Edu cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mb-12">
          {education.map((edu, i) => (
            <div
              key={edu.degree}
              className={`reveal ${inView ? 'visible' : ''} delay-${i + 3}`}
              style={{
                padding: '1.6rem', borderRadius: 16,
                border: '1px solid var(--border)', background: 'var(--card)',
                position: 'relative', overflow: 'hidden', cursor: 'default',
                transition: 'border-color 0.3s, transform 0.3s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'rgba(124,109,250,0.35)';
                e.currentTarget.style.transform = 'translateY(-3px)';
                const bar = e.currentTarget.querySelector('.edu-top-bar');
                if (bar) bar.style.transform = 'scaleX(1)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'var(--border)';
                e.currentTarget.style.transform = '';
                const bar = e.currentTarget.querySelector('.edu-top-bar');
                if (bar) bar.style.transform = 'scaleX(0)';
              }}
            >
              {/* Animated top accent */}
              <div
                className="edu-top-bar"
                style={{
                  position: 'absolute', top: 0, left: 0, right: 0, height: 2,
                  background: 'linear-gradient(90deg, var(--accent), var(--accent2))',
                  transform: 'scaleX(0)', transformOrigin: 'left',
                  transition: 'transform 0.3s ease',
                }}
              />
              <div style={{
                fontFamily: "'Space Mono', monospace", fontSize: '0.72rem',
                color: 'var(--accent3)', marginBottom: '0.5rem',
              }}>
                {edu.year}
              </div>
              <div style={{ fontSize: '0.93rem', fontWeight: 600, lineHeight: 1.4, marginBottom: '0.4rem' }}>{edu.degree}</div>
              <div style={{ fontSize: '0.82rem', color: 'var(--text2)', marginBottom: '0.9rem' }}>{edu.school}</div>
              <span style={{
                display: 'inline-block', fontSize: '0.7rem', padding: '0.2rem 0.65rem', borderRadius: '100px',
                background: 'rgba(109,250,213,0.08)', border: '1px solid rgba(109,250,213,0.18)',
                color: 'var(--accent3)',
              }}>
                {edu.badge}
              </span>
            </div>
          ))}
        </div>

        {/* Certifications / Achievements */}
        <div className={`reveal ${inView ? 'visible' : ''} delay-6`}>
          <div style={{
            fontFamily: "'Space Mono', monospace", fontSize: '0.72rem',
            color: 'var(--text2)', letterSpacing: '0.15em', textTransform: 'uppercase',
            marginBottom: '1rem',
          }}>
            Achievements & Publications
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {certifications.map((cert, i) => {
            const Inner = (
              <div
                style={{
                  padding: '1.1rem 1.4rem', borderRadius: 12,
                  border: '1px solid var(--border)', background: 'var(--card)',
                  display: 'flex', alignItems: 'flex-start', gap: '1rem',
                  transition: 'all 0.3s', textDecoration: 'none', color: 'inherit', cursor: cert.link ? 'none' : 'default',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = 'rgba(250,109,200,0.4)';
                  e.currentTarget.style.transform = 'translateX(4px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = 'var(--border)';
                  e.currentTarget.style.transform = '';
                }}
              >
                <div style={{
                  width: 40, height: 40, borderRadius: 10, flexShrink: 0,
                  background: 'rgba(250,109,200,0.08)', border: '1px solid rgba(250,109,200,0.18)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem',
                }}>
                  {cert.icon}
                </div>
                <div>
                  <div style={{ fontSize: '0.88rem', fontWeight: 500, lineHeight: 1.4, marginBottom: '0.25rem' }}>{cert.name}</div>
                  <div style={{ fontSize: '0.77rem', color: 'var(--text2)' }}>{cert.issuer}</div>
                </div>
              </div>
            );

            return (
              <div key={cert.name} className={`reveal-left ${inView ? 'visible' : ''} delay-${i + 7}`}>
                {cert.link ? (
                  <a href={cert.link} target="_blank" rel="noopener noreferrer" style={{ display: 'block', textDecoration: 'none' }}>
                    {Inner}
                  </a>
                ) : Inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
